export const buildBasicPaginatedSearchParams = (
  page: number,
  limit: number,
  searchText?: string,
  additionalParams?: Map<string, string>,
): URLSearchParams => {
  const searchParams = new URLSearchParams({
    ...(searchText && { q: searchText }),
    page: page.toString(),
    limit: limit.toString(),
  });
  if (additionalParams) {
    additionalParams.forEach((value, name) => {
      if (!value) {
        return;
      }
      searchParams.append(name, value);
    });
  }
  return searchParams;
};
